import type { Property, Entity } from '@cognitoforms/model.js';
import { PropertyConverter } from '@cognitoforms/model.js';
import { isChoiceField } from 'src/util/model';
import { migrateSelectionValue } from './selection-migration';

/**
 * Handles choice field format conversion (single-select <--> multi-select) during deserialization.
 *
 * When a choice field's type changes, existing entry data may have the old format.
 * This converter transforms values to match the current field configuration.
 *
 * Mirrors the server-side ChoiceFieldPropertyConverter behavior:
 * - Single→Multi: property expects array but value is string → wrap in array
 * - Multi→Single: property expects single but value is array → extract first element
 */
export default class ChoiceFieldConverter extends PropertyConverter {
	shouldConvert(context: Entity, prop: Property): boolean {
		return isChoiceField(prop);
	}

	deserialize(context: Entity, value: any, property: Property): any {
		return migrateSelectionValue(value, property);
	}
}
